import { Check } from "@mui/icons-material";
import { Box, Alert } from "@mui/material";

export default function FundCompletedBanner() {
  return (<Box>
    <Alert sx={{ mb: 2 }} icon={<Check fontSize="inherit" />} severity="success">
      This campaign is completed! Thank you to all our donors for your generous contributions.
    </Alert>
  </Box>)
}